import styled from "styled-components";
import { default as BaseBadge } from "../../../common/Badge";
import { default as BaseImage } from "../../../common/Image";

export const Badge = styled(BaseBadge)`
  margin-right: 0.8rem;
`;

export const Group = styled.div`
  margin-bottom: 1.6rem;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const GroupTitle = styled.h2`
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 2.2rem;
  margin-bottom: 1.2rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[800]};

  ${({ theme }) => theme.media.sm`
    font-size: 1.7rem;
    line-height: 2.4rem;
  `}
`;

export const Listing = styled.button`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 0.8rem;
  padding: 1.2rem;
  text-align: left;
  background-color: ${({ theme }) => theme.styleGuide.colors.white};
  box-shadow: ${({ theme }) => theme.styleGuide.shadows.raised};
  border-radius: 0.4rem;
  cursor: pointer;
  opacity: ${({ isGhost }) => (isGhost ? 0.5 : 1)};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ListingImage = styled(BaseImage)`
  flex-shrink: 0;
  width: 8rem;
  height: 6rem;
  margin-right: 1.6rem;
  border-radius: 0.4rem;
  overflow: hidden;
  background-color: ${({ theme }) => theme.styleGuide.colors.gray[400]};
`;

export const ListingContent = styled.div`
  min-width: 0;
`;

export const ListingAddress = styled.span`
  display: block;
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 2rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[800]};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ theme }) => theme.media.sm`
    font-size: 1.5rem;
  `};
`;

export const ListingData = styled.span`
  display: block;
  font-size: 1.6rem;
  font-weight: 600;
  line-height: 2.2rem;
  color: ${({ theme }) => theme.styleGuide.colors.gray[900]};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ theme }) => theme.media.sm`
    font-size: 1.7rem;
    line-height: 2.4rem;
  `};
`;
